import { logo } from '@clofo/ui/images'
import { useTranslation } from '@clofo/i18n'
import { ForgotPasswordForm } from '../components/forgot-password-form'

export const ForgotPasswordPage = () => {
  const { t } = useTranslation()

  return (
    <div className='flex flex-col bg-background items-center justify-center'>
      <img src={logo} alt='Closing Folders' className='my-13 h-15' />
      <div className='w-full max-w-xl px-4'>
        <h1 className='text-xl font-semibold mb-6'>{t('login.forgot.title')}</h1>
        <ForgotPasswordForm />
      </div>
    </div>
  )
}
